import { LocalAuthProvider } from "@/lib/local-auth";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return <LocalAuthProvider>{children}</LocalAuthProvider>;
}
